import React, { useState,useEffect } from 'react';
import './userview.css';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Paper, Select, MenuItem, FormControl, InputLabel, Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button } from '@mui/material';
import { useNavigate,useParams } from 'react-router-dom';
import CryptoJS from 'crypto-js';
import ApiService from '../../Api/ApiController';
import Swal from 'sweetalert2';
export default function UserView() {
  const {userId} = useParams();
    const [showPassword, setShowPassword] = useState(false);
  const [open, setOpen] = useState(false);
  const  navigate = useNavigate();
  const [user,setUser] = useState({});
  const [wallet,setwallet] = useState(0);
    const [openEditUser, setOpenEditUser] = useState(false);
      const [orderList, setOrderList] = useState([]);
        const [pagination, setPagination] = useState({});
        const [page,setpage] = useState(1);
const [editForm, setEditForm] = useState({
  name: "",
  mobile_number: "",
  username: "",
  adhar_number: "",
  pan_card_number: "",
  adharcard_photo: null,
  pan_card_photo: null,
  bank_statement_photo: null,
  signature_photo: null,
});

useEffect(() => {
  if (user && openEditUser) {
    setEditForm({
      name: user.name || "",
      email: user.email || "",
      mobile_number: user.mobile_number || "",
      username: user.username || "",
      adhar_number: user.adhar_number || "",
      pan_card_number: user.pan_card_number || "",
      adharcard_photo: null,
      pan_card_photo: null,
      bank_statement_photo: null,
      signature_photo: null,
    });
  }
}, [user, openEditUser]);
    const userdetails = ()=>{
      ApiService.userDetails({
        user_id:userId
      }).then((response)=>{
        if(response.data.status === true){
              setUser(response.data.data);
              setwallet(response.data.data.wallet)
              console.log(response.data.data)
        }else{
          setUser({})
        }
      })
    }

useEffect(()=>{
  userdetails();
},[])
  // Handle redirection with encrypted data
  const handleRedirect = () => {
    // Get the encrypted data
    const token = CryptoJS.AES.encrypt(JSON.stringify({
      userId: user._id,
      userName: user.name
      }), 'secret-key').toString();

    // Redirect to the create order page with encrypted info in the URL
    navigate(`/user/order/create/${encodeURIComponent(token)}`);
  };

  const userStatusupdate = (event)=>{
    const newStatus = event.target.value;

    Swal.fire({
      title: 'Are you sure?',
      text: `Do you want to update the status to ${newStatus}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, update it!',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if(result.isConfirmed){
        ApiService.updateStatusUser({
          user_id:user._id,
          status: newStatus
        }).then((response)=>{
          if(response.data.status === true){
            Swal.fire({
              icon:'success',
              title:response.data.message
          });
          userdetails();
          
          }else{
            Swal.fire({
                icon:'error',
                title:response.data.message
            });
          }
  }).catch((error)=>{
    Swal.fire({
      icon:'error',
      title:error.response.data.message
  });
  })
      }
    });
    
  }

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const editfund = ()=>{
    ApiService.edituserfunds({
      amount:parseFloat(wallet),
      user_id:user._id

    }).then((response)=>{
      if(response.data.status === true){
        Swal.fire({
          toast: true,
          position: 'top-end', // You can change this to 'bottom-end', 'bottom-left', etc.
          icon: 'success',
          title: response.data.message,
          showConfirmButton: false,
          timer: 3000, // Duration in milliseconds
          timerProgressBar: true,
        });
        handleClose();
        userdetails();
      }else{
        Swal.fire({
          toast: true,
          position: 'top-end', // You can change this to 'bottom-end', 'bottom-left', etc.
          icon: 'error',
          title: response.data.message,
          showConfirmButton: false,
          timer: 3000, // Duration in milliseconds
          timerProgressBar: true,
        });
      }

    }).catch((error)=>{
      console.log(error)
      Swal.fire({
        toast: true,
        position: 'top-end', // You can change this to 'bottom-end', 'bottom-left', etc.
        icon: 'error',
        title:error.response.data.message,
        showConfirmButton: false,
        timer: 3000, // Duration in milliseconds
        timerProgressBar: true,
      });
    })
  }
  const handleChange = (e) => {
  const { name, value } = e.target;
  setEditForm((prev) => ({ ...prev, [name]: value }));
};

// Handle file upload
const handleFileChange = (e) => {
  const { name, files } = e.target;
  setEditForm((prev) => ({ ...prev, [name]: files[0] }));
};

// Submit form
const handleSaveUser = async () => {
  try {
    const formData = new FormData();
    Object.keys(editForm).forEach((key) => {
      if (editForm[key]) formData.append(key, editForm[key]);
    });
    formData.append("user_id", user._id);

    const response = await ApiService.updateUser(user._id,formData);

    if (response.data.status === true) {
      Swal.fire({
        icon: "success",
        title: response.data.message,
      });
      setOpenEditUser(false);
      userdetails(); // refresh user data
    } else {
      Swal.fire({
        icon: "error",
        title: response.data.message,
      });
    }
  } catch (error) {
    console.error(error);
    Swal.fire({
      icon: "error",
      title: error.response?.data?.message || "Something went wrong",
    });
  }
};
 const getorders = () => {
   
    ApiService.orderList({user_id:userId})
      .then((response) => {
        if (response.data.status === true) {
          setOrderList(response.data.data.data);
          setPagination(response.data.data.paginator);
        } else {
          console.log(response.data);
        }
      })
      .catch((error) => console.log(error));
  };
  const updateOrderstatus = (orderId, newStatus) => {
    ApiService.updateOrderstatus({
      order_id: orderId,
      status: newStatus,
    })
      .then((response) => {
        if (response.data.status === true) {
          Swal.fire({
            icon: "success",
            title: response.data.message,
          });
          getorders();
        } else {
          Swal.fire({
            icon: "error",
            title: response.daata.message,
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: error.response.daata.message,
        });
      });
  };
    const statusOptions = [
    { value: "", label: "All" },
    { value: "open", label: "Open" },
    { value: "closed", label: "Closed" },
    { value: "rejected", label: "Rejected" },
    { value: "holding", label: "Holding" },
    { value: "exited", label: "Execute" },
  ];
  useEffect(()=>{
 getorders();
  },[page])
  return (
    <>
    {user.status === 'approve' &&( <section className="header_user_view">
    <button onClick={() => setOpenEditUser(true)}>Edit User</button>
      <button  onClick={handleOpen}>Edit funds</button>
      <button onClick={handleRedirect}> <span><i class='bx bx-plus-circle'></i></span> Create Order</button>
    </section>)}
<Dialog open={openEditUser} onClose={() => setOpenEditUser(false)} fullWidth maxWidth="md">
  <DialogTitle>Edit User Details</DialogTitle>
  <DialogContent dividers>
    {/* Editable Fields */}
    <TextField
      margin="dense"
      label="Name"
      fullWidth
      value={editForm.name}
      onChange={(e) => setEditForm({ ...editForm, name: e.target.value })}
    />
    <TextField
      margin="dense"
      label="Mobile Number"
      fullWidth
      value={editForm.mobile_number}
      onChange={(e) => setEditForm({ ...editForm, mobile_number: e.target.value })}
    />
    <TextField
      margin="dense"
      label="Aadhar Number"
      fullWidth
      value={editForm.adhar_number}
      onChange={(e) => setEditForm({ ...editForm, adhar_number: e.target.value })}
    />
    <TextField
      margin="dense"
      label="PAN Card Number"
      fullWidth
      value={editForm.pan_card_number}
      onChange={(e) => setEditForm({ ...editForm, pan_card_number: e.target.value })}
    />

    {/* Document Uploads */}
    <div style={{ marginTop: "20px" }}>
  <Typography variant="h6" style={{ marginBottom: "15px" }}>
    Upload Documents
  </Typography>

  {[
    { label: "Aadhar Card", key: "adharcard_photo", preview: user.adharcard_photo },
    { label: "PAN Card", key: "pan_card_photo", preview: user.pan_card_photo },
    { label: "Bank Statement", key: "bank_statement_photo", preview: user.bank_statement_photo },
    { label: "Signature", key: "signature_photo", preview: user.signature_photo },
  ].map((doc, index) => (
    <div
      key={index}
      style={{
        display: "flex",
        alignItems: "center",
        marginBottom: "15px",
        padding: "10px",
        border: "1px solid #ddd",
        borderRadius: "8px",
        background: "#fafafa",
      }}
    >
      {/* Label and File Input */}
      <div style={{ flex: 1 }}>
        <label style={{ fontWeight: "bold", display: "block", marginBottom: "5px" }}>
          {doc.label}
        </label>
        <input
          type="file"
          onChange={(e) =>
            setEditForm({ ...editForm, [doc.key]: e.target.files[0] })
          }
        />
      </div>

      {/* Preview Image */}
      {doc.preview && (
        <div style={{ marginLeft: "15px" }}>
          <img
            src={doc.preview}
            alt={doc.label}
            width="100"
            height="70"
            style={{
              objectFit: "cover",
              borderRadius: "5px",
              border: "1px solid #ccc",
            }}
          />
        </div>
      )}
    </div>
  ))}
</div>

  </DialogContent>

  <DialogActions>
    <Button onClick={() => setOpenEditUser(false)} color="secondary">Cancel</Button>
    <Button onClick={handleSaveUser} color="primary">Save</Button>
  </DialogActions>
</Dialog>


    <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Edit Funds</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Enter Amount"
                        type="number"
                        fullWidth
                        variant="outlined"
                        value={wallet} 
                        onChange={(e)=>setwallet(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={editfund} color="primary">
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
    <section className="user_view-container">
      <div className="user_view-card">
        <h1 className="user_view-title">User Details</h1>
        <div className="user_view-info">
            <div className='user_view_status_row'>
          <p><strong>Name:</strong> {user.name}</p>
          {user.status && (
  <FormControl sx={{ width: '200px' }}>
    <InputLabel>Status</InputLabel>
    <Select
      value={user.status}
      label="Status"
      onChange={userStatusupdate}
    >
      <MenuItem value="pending">Pending</MenuItem>
      <MenuItem value="approve">Approved</MenuItem>
    </Select>
  </FormControl>
)}

            </div>
          <p><strong>Mobile Number:</strong> {user.mobile_number}</p>
          <p><strong>Email:</strong> {user.email}</p>
          <p><strong>Adhar Number:</strong> {user.adhar_number}</p>
          <p><strong>PAN Card Number:</strong> {user.pan_card_number}</p>
          <p><strong>Wallet:</strong> {user.wallet}</p>
          <p><strong>Status:</strong> {user.status}</p>
          <p><strong>Is Deleted:</strong> {user.is_deleted ? "Yes" : "No"}</p>
          <p><strong>Username:</strong> {user.username}</p>
          <p><strong>Created At:</strong> {new Date(user.createdAt).toLocaleString()}</p>
          <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "10px 14px",
        background: "#f5f5f5",
        borderRadius: "6px",
        width: "320px"
      }}
    >
      <strong style={{ minWidth: "80px" }}>Password</strong>

      <span style={{ flex: 1 }}>
        {showPassword ? user.password : "••••••••"}
      </span>

      <button
        onClick={() => setShowPassword(!showPassword)}
        style={{
          padding: "4px 8px",
          fontSize: "12px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          cursor: "pointer",
          background: "#fff"
        }}
      >
        {showPassword ? "Hide" : "Show"}
      </button>
    </div>
        </div>
      </div>

      <div className="user_view-card user_view-images">
        <h2 className="user_view-title">Document Images</h2>
        <div className="user_view-image-group">
          <div className="user_view-image-item">
            <strong>Adharcard Photo:</strong>
            <img src={user.adharcard_photo} alt="Adharcard" />
          </div>
          <div className="user_view-image-item">
            <strong>PAN Card Photo:</strong>
            {user.pan_card_photo ? (
              <img src={user.pan_card_photo} alt="PAN Card" />
            ) : (
              <span>No Image Available</span>
            )}
          </div>
          <div className="user_view-image-item">
            <strong>Bank Statement Photo:</strong>
            <img src={user.bank_statement_photo} alt="Bank Statement" />
          </div>
          <div className="user_view-image-item">
            <strong>Signature Photo:</strong>
            {user.signature_photo ? (
              <img src={user.signature_photo} alt="Signature" />
            ) : (
              <span>No Image Available</span>
            )}
          </div>
        </div>
      </div>

      <div className="user_view-card">
        <h2 className="user_view-title">Bank Details</h2>
        <table className="user_view-table">
          <thead>
            <tr>
              <th>Account Number</th>
              <th>Bank Name</th>
              <th>IFSC Code</th>
            </tr>
          </thead>
          <tbody>
          {user.bank_account?.map((bank, index) => (
        <tr
          key={index}
          style={{
            backgroundColor: bank.is_primary ? "#e0f7e9" : "transparent",
          }}
        >
          <td>
            {bank.is_primary && (
              <span
                style={{
                  display: "inline-block",
                  width: "10px",
                  height: "10px",
                  marginRight: "5px",
                  borderRadius: "50%",
                  backgroundColor: "green",
                }}
              ></span>
            )}
            {bank.account_number}
          </td>
          <td>{bank.bank_name}</td>
          <td>{bank.ifsc_code}</td>
        </tr>
      ))}
          </tbody>
        </table>
      </div>

      <div className='user_view-order'>
        <div component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>S.No.</TableCell>
                <TableCell>Stock Name</TableCell>
                <TableCell>User Name</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Entry Price</TableCell>
                <TableCell>Exit Price</TableCell>
                <TableCell>Profit/Loss</TableCell>
                <TableCell>Order Status</TableCell>
                {/* <TableCell>Action</TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {orderList.map((order, index) => (
                <TableRow key={order._id}>
                  <TableCell data-label="S.No.">{index + 1}</TableCell>
                  <TableCell data-label="Stock Name">
                    {order.stock_name}
                  </TableCell>
                  <TableCell data-label="User Name">
                    {order.user_id.name}
                  </TableCell>
                  <TableCell data-label="Quantity">{order.quantity}</TableCell>
                  <TableCell data-label="Entry Price">
                    {order.entry_price}
                  </TableCell>
                  <TableCell data-label="Exit Price">
                    {order.exit_price}
                  </TableCell>
                  <TableCell
                    data-label="Profit/Loss"
                    sx={{
                      color: order.order_type === "profit" ? "green" : "red",
                    }}
                  >
                    {order.amount}
                  </TableCell>
                  <TableCell data-label="Order Status">
                    {/* <Select
                      options={statusOptions.filter(
                        (option) => option.value !== ""
                      )}
                      value={statusOptions.find(
                        (option) => option.value === order.order_status
                      )}
                      onChange={(selectedOption) =>
                        updateOrderstatus(order._id, selectedOption.value)
                      }
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          width: "120px",
                          minHeight: "30px",
                        }),
                        menu: (provided) => ({
                          ...provided,
                          width: "120px",
                        }),
                      }}
                    /> */}
                    <span style={{ textTransform: "capitalize" }}>
  {statusOptions.find(option => option.value === order.order_status)?.label || "N/A"}
</span>
                  </TableCell>
                  {/* <TableCell data-label="Action">
                    
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => openEditDialog(order)}
                  >
                    Edit
                  </Button>
                    <button
                      className="table_btn"
                      onClick={() => deleteorder(order._id)}
                    >
                      <i className="bx bx-trash"></i>
                    </button>
                  </TableCell> */}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </section>
    </>

  );
}
